module.exports = __webpack_public_path__ + "static/media/linear_equations.cc08fd8c.png";